import React, { useState } from 'react';
import NotificationIcon from '../../../../assets/svg/IconBell.svg'
import { imageData, isImageEdited, showCloseModal, isBeneficiaryModified, setAncPregBackHandler, updateAncService, setFamilyPlanningBackHandler, updatePNC, setLmpDate, setShowServices, setShowPregnancy, setPregnancyOngoing, setCheckIsHrp, setIsHRP, updateChild, updateChildVerifyFromGrid, setBenfDeathDetails, setBeneficiaryPregnancyHistory, setChildBenefList } from '@store/actions/beneficiaryAction';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@components/common/Button';
import { RootState } from '@store/reducers';
import { useLocation, useNavigate } from 'react-router-dom';
import Pencil from '../../../../assets/svg/pencil.svg';
import {
    setBeneficiaryDetails,
    updateDeliveryDetails,
} from '@store/actions/beneficiaryAction';
import { noConflict } from 'lodash';
import DeathNotificationModal from './DeathNotificationModal';
import DeathNotificationFormModal from './DeathNotificationFormModal';
import { decodeWithKeyAndShift } from '@utils/base64Utils';
import { buttonNames, benfTabs } from '@constants/appConstants';
import { COMMON_CONSTANTS } from '@constants/index';
import { PagePermission } from '@services/usePermission';
interface ChildProps {
    flow: string;
    loading: boolean;
    beneficiary: any;
    updateHandlerUpdate: any
    benefDeathDetails: any
    id: any
    childDetail:any
    currentTab: string;
}
const BenificiaryActions = (props: ChildProps) => {
    const { flow, loading, beneficiary, updateHandlerUpdate, benefDeathDetails, id, currentTab,childDetail } = props;
    const navigate = useNavigate();
    const beneficiaryEdited = useSelector((state: RootState) => state.beneficiary.isBeneficiaryModified);
    const dispatch = useDispatch();
    const location:any = useLocation();
    const buttonName = flow === COMMON_CONSTANTS.VIEW ? buttonNames.editDetails : buttonNames.submit
    const icon = buttonName === buttonNames.editDetails ? <Pencil /> : ''
    const notificationIcon = <NotificationIcon />
    const userDetails = localStorage.getItem('userDetails');
    const decodedUserData=JSON.parse(decodeWithKeyAndShift(userDetails));
    const [showDeathNotification, setShowDeathNotification] = useState(false);
    const [showDeathNotificationForm, setShowDeathNotificationForm] = useState(false);
    const [userData, setUserData] = useState(decodedUserData);
    const [disabledDeathNotification, setDisabledDeathNotification] = useState(beneficiary?.notification_sent_by_asha)
    const closeDeathNotification = () => {
        setShowDeathNotification(false);
    };

    const caneditBenef = PagePermission("Benf", "Benf_EdPg")

    return (
        <>
            {currentTab === benfTabs.overview &&
                <div style={{ display: "flex", gap: "10px" }}>
                    {
                        (userData?.user_designation_name === "ASHA" && flow === COMMON_CONSTANTS.VIEW)?(<Button
                            id="notify-death"
                            buttonName={'Notify Death'}
                            colorType={'notification'}
                            icon={notificationIcon}
                            iconPosition={'left'}
                            onClick={() => {
                                setShowDeathNotification(true);
                            }}
                            disabled={disabledDeathNotification || beneficiary?.notification_sent_by_asha}
                        />):(<></>)
                    }
                    {flow !== COMMON_CONSTANTS.VIEW && <Button
                        onClick={() => {
                            if (beneficiaryEdited) {
                                dispatch(showCloseModal(true))
                            }
                            else {
                                const navigateState = location?.state ? JSON.parse(location.state) : null;
                                const isFlowFromEdit = navigateState?.flow === 'toEdit' ? true : false;
                                navigate(-1);
                                dispatch(isImageEdited(false));
                                dispatch(imageData(''));
                                dispatch(isBeneficiaryModified(false))
                                dispatch(updatePNC('pncOnSameDay', false));
                                dispatch(updateChild("updateChildVerifyFromView", false)); 
                                dispatch(updateChildVerifyFromGrid(false));
                                dispatch(updateAncService("viewPregnancyDetails", []));
                                dispatch(updateAncService("currPregnancyId", ''));
                                if (!isFlowFromEdit) {
                                    dispatch(setShowPregnancy(false));
                                    dispatch(setShowServices(false));
                                    dispatch(setPregnancyOngoing(false));
                                    dispatch(setIsHRP(false));
                                    beneficiary?.benf_type_name !== COMMON_CONSTANTS.CHILD ? dispatch(setBeneficiaryDetails([])) : ''
                                    dispatch(setBenfDeathDetails([]));
                                    dispatch(setBeneficiaryPregnancyHistory([]));
                                    dispatch(setChildBenefList([]));
                                }
                            }
                        }}
                        disabled={false}
                        id="cancel"
                        buttonName={buttonNames.cancel}
                        colorType={'save'}
                        icon={''}
                        iconPosition={'right'}

                    />}
                    {!loading && !benefDeathDetails?.[0]?.is_dead && caneditBenef &&<Button
                        onClick={() => {
                            const navigateState={...beneficiary, flow:'toEdit'};
                            flow === COMMON_CONSTANTS.VIEW ? navigate(`/beneficiaries/edit/${id}`, {
                                state: JSON.stringify(navigateState),
                            }) : updateHandlerUpdate()
                        }}
                        disabled={(childDetail?.is_dead)?true:false}
                        id={flow === COMMON_CONSTANTS.VIEW ? 'edit-details' : 'save-details'}
                        buttonName={buttonName}
                        colorType={'primary'}
                        icon={icon}
                        iconPosition={'left'}
                    />}
                </div>
            }
            <DeathNotificationModal showModal={showDeathNotification} setShowDeathNotification={setShowDeathNotification} setShowDeathNotificationForm={setShowDeathNotificationForm} />
            <DeathNotificationFormModal showModal={showDeathNotificationForm} setShowDeathNotificationForm={setShowDeathNotificationForm} beneficiary={beneficiary} setShowDeathNotification={setShowDeathNotification} setDisabledDeathNotification={setDisabledDeathNotification}/>
        </>
    )
}

export default BenificiaryActions;